<template>
  <section class="pt-20 bg-black">
    <scroll-panaroma-mousewheel></scroll-panaroma-mousewheel>
    <swiper
      :slides-per-view="0.7"
      :space-between="0"
      :direction="horizontal"
      :mousewheel="{ invert: false, releaseOnEdges: true }"
      :autoplay="{
        delay: 300,
        disableOnInteraction: true,
      }"
      :freeMode="true"
      class="panaroma-container hidden sm:block"
    >
      <swiper-slide
        ><img :src="require('../assets/home/shogun-1.jpg')" alt=""
      /></swiper-slide>
      <swiper-slide
        ><img :src="require('../assets/home/shogun-2.jpg')" alt=""
      /></swiper-slide>
      <swiper-slide
        ><img :src="require('../assets/home/shogun-3.jpg')" alt=""
      /></swiper-slide>
      <swiper-slide
        ><img :src="require('../assets/home/shogun-4.jpg')" alt=""
      /></swiper-slide>
      <swiper-slide
        ><img :src="require('../assets/home/shogun-5.jpg')" alt=""
      /></swiper-slide>
    </swiper>
  </section>
</template>

<script>
import SwiperCore, { Mousewheel, Autoplay } from "swiper";
import ScrollPanaromaMousewheel from "../components/ScrollPanaromaMousewheel";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.scss";

SwiperCore.use([Mousewheel, Autoplay]);
export default {
  data() {
    return {};
  },
  components: {
    Swiper,
    SwiperSlide,
    ScrollPanaromaMousewheel
  }
};
</script>

<style scoped>
</style>